import { render, staticRenderFns } from "./bnbCollectionOther.vue?vue&type=template&id=2f87080c&scoped=true"
import script from "./bnbCollectionOther.vue?vue&type=script&lang=js"
export * from "./bnbCollectionOther.vue?vue&type=script&lang=js"
import style0 from "./bnbCollectionOther.vue?vue&type=style&index=0&id=2f87080c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87080c",
  null
  
)

export default component.exports